import { hydrateRoot, createRoot } from "react-dom/client";
import App from "./App.js";
import {
  getAnalyticsConsent,
  initGoogleAnalytics,
  initMetaPixel,
} from "./lib/analytics";
import "./index.css";

// Loi 25 / GDPR: GA and the Meta Pixel only load for visitors who accepted
// the cookie banner.
if (getAnalyticsConsent() === "granted") {
  initGoogleAnalytics();
  initMetaPixel();
}

const rootEl = document.getElementById("root")!;

// Prerendered routes ship server-rendered markup → hydrate it. Hosts that
// answer unknown paths with another route's HTML (home page or 404.html) would
// fail hydration, so only hydrate markup rendered for this exact path.
// Non-prerendered routes (e.g. /invite/:token) get an empty root → mount normally.
const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
if (rootEl.hasChildNodes() && rootEl.dataset.prerenderedPath === currentPath) {
  hydrateRoot(rootEl, <App />);
} else {
  createRoot(rootEl).render(<App />);
}
